import { DebtEquityValues, DebtEquityResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

export function calculateDebtEquity(values: DebtEquityValues, t?: ToolsTranslations['debtEquity']): DebtEquityResult {
  const { totalDebt, equity } = values;

  if (totalDebt < 0) {
    return { ratio: null, isValid: false, message: t?.invalid.totalDebt ?? 'Skulder måste vara 0 eller mer' };
  }
  if (equity <= 0) {
    return { ratio: null, isValid: false, message: t?.invalid.equity ?? 'Eget kapital måste vara större än 0' };
  }

  const ratio = Math.round((totalDebt / equity) * 100) / 100;

  if (!isFinite(ratio)) {
    return { ratio: null, isValid: false, message: t?.invalid.generic ?? 'Ogiltiga värden' };
  }

  return { ratio, isValid: true };
}


